module.exports = __webpack_public_path__ + "img/09.60bed7d2.png";